import {makeStyles} from '@material-ui/core';

export default makeStyles(theme => ({
  formControl: {
    width: '100%',
    margin: theme.spacing(1),
  }
}));

